export const isInShoppingPage = () => window.location.pathname.split('/').includes('shopping');
